import { useEffect, useRef, useState } from 'react';

interface useOnScreenInterface {
  onChangeVisibility?: (visibility: boolean) => void;
  options?: IntersectionObserverInit;
  defaultState?: boolean;
  disable?: boolean;
}

export function useVisibility<T extends Element>(args?: useOnScreenInterface) {
  const ref = useRef<T>(null);
  const { onChangeVisibility, options, defaultState, disable } = args ?? {};
  const [visible, setVisible] = useState<boolean>(defaultState ?? false);

  useEffect(() => {
    if (disable) return;
    const { current } = ref;
    let observer: IntersectionObserver;

    if (current != null) {
      observer = new IntersectionObserver(([entry]) => {
        setVisible(entry.isIntersecting);
        if (onChangeVisibility) {
          onChangeVisibility(entry.isIntersecting);
        }
      }, options);
      observer.observe(current);
    }

    return () => {
      if (current != null && observer) {
        observer.unobserve(current);
      }
    };
  }, [onChangeVisibility, options, disable]);

  return { ref, visible };
}
